import { GodownDetail as ConsoleGodownDetail } from "../console/GodownDetail";

// The godown page is shared with the state-head console; this wrapper
// just fixes the base path for district-head routes.
export function GodownDetail() {
  return <ConsoleGodownDetail basePath="/dh" />;
}
